/**
 * Core components.
 *
 * @module postprocessing/core
 */

export { Disposable } from "./Disposable.js";
export { EffectComposer } from "./EffectComposer.js";
export { Resizable } from "./Resizable.js";



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/postprocessing/src/core/index.js
// module id = 137
// module chunks = 0